import moment from "moment"
import Service from "../../src/components/api/Service"
import { snackbar } from "cids-cgi/lib/util"

export default class AvaliacaoClima {

    context = null
    questionario = []
    radioGroup = []
    dadosPessoa = null
    isShowError = []
    flagValidation = true
    loading = false
    carregar = false
    attrs = {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
    }
    constructor(context) {
        this.context = context
    }

    async getQuestionario(agenda) {
        try {
            this.carregar = true
            const api = new Service()
            this.dadosPessoa = agenda
            let questionarios = await api.getBuscaQuestionario(agenda.codQuestionario)
            this.questionario = questionarios.ttQuestTitulo.map(item => {
                for (let pergunta of item.ttQuestPergunta) {
                    pergunta["codOpcao"] = null
                    pergunta["codOpcaoMulti"] = []
                    pergunta["naoSeAplica"] = false
                    pergunta["descricaoPergunta"] = ""
                    pergunta["isShowError"] = true
                }
                return item
            })

        } catch (e) {
            snackbar.show({ message: e })
        } finally {
            this.carregar = false

        }
    }

    async enviar() {
        try {
            this.loading = true

            this.validaCard2()

            if (this.flagValidation) {
                const api = new Service()
                let codPessoa = this.dadosPessoa.codPessoa
                let codEmpregado = this.dadosPessoa.codEmpregado
                let codQuestionario = this.dadosPessoa.codQuestionario
                let codEmp = this.dadosPessoa.codEmp
                let codTreinamento = this.dadosPessoa.codTreinamento
                let codTurma = this.dadosPessoa.codTurma
                let ttPessoaAvaliacaoQuest = []
                this.questionario.forEach(i => {

                    i.ttQuestPergunta.forEach(item => {
                        if (item.codOpcao != null || item.codOpcaoMulti.length > 0 || item.descricaoPergunta != '') {

                            if (item.codOpcaoMulti.length > 0) {
                                let sequencia = 0
                                for (let codOpcao of item.codOpcaoMulti) {

                                    ttPessoaAvaliacaoQuest.push({
                                        codPessoa: codPessoa,
                                        codQuestionario: codQuestionario,
                                        dtAvaliacao: moment().format("YYYY-MM-DD"),
                                        codTitulo: item.codTitulo,
                                        codPergunta: item.codPergunta,
                                        codOpcao: codOpcao,
                                        sequencia: sequencia,
                                        seqAvaliacao: 0,
                                        observacao: "",
                                        descricao: item.descricaoPergunta,
                                        naoSeAplica: item.naoSeAplica,
                                        codTreinamento: codTreinamento,
                                        codTurma: codTurma,
                                    })
                                    sequencia++
                                }
                            } else {
                                item.seqAvaliacao = 0
                                ttPessoaAvaliacaoQuest.push({
                                    codPessoa: codPessoa,
                                    codQuestionario: codQuestionario,
                                    dtAvaliacao: moment().format("YYYY-MM-DD"),
                                    codTitulo: item.codTitulo,
                                    codPergunta: item.codPergunta,
                                    codOpcao: item.codOpcao != null ? item.codOpcao : 0,
                                    sequencia: 0,
                                    seqAvaliacao: 0,
                                    observacao: "",
                                    descricao: item.descricaoPergunta,
                                    naoSeAplica: item.naoSeAplica,
                                    codTreinamento: codTreinamento,
                                    codTurma: codTurma,
                                })
                            }
                        }
                    })
                })

                let ttPessoaAvaliacao = [
                    {
                        codPessoa: codPessoa,
                        codEmpregado: codEmpregado,
                        codQuestionario: codQuestionario,
                        dtAvaliacao: moment().format("YYYY-MM-DD"),
                        dtPreenche: moment().format("YYYY-MM-DD"),
                        seqAvaliacao: 0,
                        codEmp: codEmp,
                        avaliacao: "",
                        observacao: "",
                        escolaridade: "",
                        tempoEmpresa: 0,
                        codUnidade: 0,
                        codFil: 0,
                        nivel: "",
                        codTreinamento: codTreinamento,
                        codTurma: codTurma,
                        ttPessoaAvaliacaoQuest: ttPessoaAvaliacaoQuest
                    }
                ]
                const response = await api.gravaPessoaAvaliacao(ttPessoaAvaliacao)
                snackbar.show({ message: response, color: "primary" })

                this.context.dialogQuestionario = false
                this.context.buscarAgenda()
                //this.context.$router.push({ path: 'avaliacao' })
                // this.getQuestionario()
            } else {
                snackbar.show({ message: "Existem perguntas a serem respondidas", color: "red", timeout: 5000 })
            }
        } catch (error) {
            snackbar.show({ message: error, timeout: 5000 })
        } finally {
            this.loading = false
        }
    }
    validaCards(indexQuestionario, indexpergunta) {
        if (this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].naoSeAplica) {
            this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].codOpcao = null
            this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].codOpcaoMult = []
            this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].descricaoPergunta = ""


            this.context.$refs['pergunta_' + indexQuestionario + "_" + indexpergunta][0].resetValidation()
        } else {
            this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].naoSeAplica = false
        }
        this.questionario[indexQuestionario].ttQuestPergunta[indexpergunta].isShowError = true
    }

    validaCard2() {
        this.flagValidation = true
        this.questionario = this.questionario.map((i, index) => {
            i.ttQuestPergunta.forEach((item, indice) => {
                if (item.naoSeAplica) {
                    item.isShowError = true
                } else {
                    item.isShowError = this.context.$refs['pergunta_' + index + "_" + indice][0].validate()
                    if (!item.isShowError) {
                        this.flagValidation = false
                    }
                }
            })
            return i
        })
    }
}